import {
  FETCH_REFERRED_USERS_REQUEST,
  FETCH_REFERRED_USERS_SUCCESS,
  FETCH_REFERRED_USERS_FAILURE,
} from '../../constants/ActionTypes';

const referredUsers = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_REFERRED_USERS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_REFERRED_USERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_REFERRED_USERS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

export default referredUsers;
